import $http from '../../axios'
import { Notification } from 'element-ui'

export async function fetchCountries({ commit, state }) {
  if (state.countries.length) return

  await $http
    .get('/api/pais/')
    .then(response => {
      const countries = response.data.data
    ? response.data.data
    : response.data
      commit('setCountries', countries)
    })
    .catch(error => {
      Notification.error({
        title: 'Error!',
        message: error.message,
        type: 'error',
        duration: 1500,
        customClass: 'notification-box'
      })
    })
}



// WEBPACK FOOTER //
// ./src/modules/countries/actions.js